import {GET_MAP, MAP_CREATED, MAP_MOVE, MAP_REMOVE_OVERLAY, MAP_ZOOM} from '../Map/EventKeys'

export default {
  name: 'BaseMapTool',
  computed: {
    eventKeyMap () {
      return {
        DATA_CHANGE: 'DataChange'
      }
    }
  },
  methods: {
    onMapReady (map) {},
    onLngLatChange (data) {},
    onDataChange (data) {},
    onClear () {},
    handleMapZoomChanged (event) {},
    handleMapMoving (event) {},
    lngLatChange () {
      let {data, map} = this

      if (data && map) {
        this.onLngLatChange(map, data)
        // this.onDataChange(map, data)
      }
    },
    dataChange () {
      let {data, map} = this

      if (data && map) {
        this.onDataChange(map, data)
      }
    },
    handleMapReady (map) {
      this.map = map
      this.onMapReady(map)
      this.lngLatChange()
    },
    handleLngLatChange (data) {
      this.data = data
      this.lngLatChange()
    },
    handleDataChange (data) {
      this.data = data
      this.dataChange()
    },
    handleClear () {
      this.onClear()
    }
  },
  created () {
    let eventBus = this.$eventBus
    let eventKeyMap = this.eventKeyMap
    eventBus.once(MAP_CREATED, this.handleMapReady)
    eventBus.on(MAP_ZOOM, this.handleMapZoomChanged)
    eventBus.on(MAP_MOVE, this.handleMapMoving)
    eventBus.on(eventKeyMap.LNG_LAT_CHANGE, this.handleLngLatChange)
    eventBus.on(eventKeyMap.DATA_CHANGE, this.handleDataChange)
    eventBus.on(eventKeyMap.CLEAR, this.handleClear)
    eventBus.emit(GET_MAP, this.handleMapReady)
  },
  beforeDestroy () {
    let eventBus = this.$eventBus
    let {eventKeyMap, overlays} = this

    eventBus.off(eventKeyMap.LNG_LAT_CHANGE, this.handleLngLatChange)
    eventBus.off(eventKeyMap.DATA_CHANGE, this.handleDataChange)
    eventBus.off(eventKeyMap.CLEAR, this.handleClear)
    eventBus.off(MAP_ZOOM, this.handleMapZoomChanged)
    eventBus.off(MAP_MOVE, this.handleMapMoving)

    if (overlays) {
      eventBus.emit(MAP_REMOVE_OVERLAY, overlays)
    }

    this.data = this.map = null
  }
}



// WEBPACK FOOTER //
// ./src/components/MapTools/BaseMapTool.js